import React from 'react';
import { ShieldAlert } from 'lucide-react';

const ConfirmUpdateModal = ({ onConfirm, onCancel, uncompletedCount }) => {
  return (
    <div className="fixed inset-0 bg-slate-950/80 backdrop-blur-sm flex items-center justify-center z-50 animate-in fade-in duration-300">
      <div className="bg-slate-900 border border-slate-800 rounded-3xl shadow-2xl p-6 sm:p-8 max-w-sm w-full m-4 text-center">
        <div className="mx-auto bg-amber-500/10 border-4 border-amber-500/20 rounded-full w-20 h-20 flex items-center justify-center mb-6">
          <ShieldAlert className="w-10 h-10 text-amber-400" />
        </div>
        <h2 className="text-2xl font-black text-slate-100 mb-2">Atualizar Torneio?</h2>
        <p className="text-slate-400 mb-8">
          Você tem certeza? A configuração do torneio será recalculada. <strong>{uncompletedCount} partidas</strong> que ainda não foram finalizadas serão perdidas.
        </p>
        <div className="flex gap-3 justify-center">
          <button 
            onClick={onCancel}
            className="flex-1 bg-slate-800 hover:bg-slate-700 text-slate-300 font-bold py-3 rounded-xl transition-all"
          >
            Cancelar
          </button>
          <button 
            onClick={onConfirm}
            className="flex-1 bg-amber-600 hover:bg-amber-500 text-white font-bold py-3 rounded-xl transition-all"
          >
            Sim, Atualizar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmUpdateModal;
